import React, { useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import { usePlacesWidget } from "react-google-autocomplete";

const Input = ({
	type,
	label,
	src,
	valueToActive,
	email,
	value,
	fade,
	fadeOut,
	disabled,
	required,
	hidden,
	style,
	setAddressStripeInfos,
	setPostalCodeStripeInfos,
	setCityStripeInfos,
	setUserInfos
}) => {


	const { ref } = usePlacesWidget({
		apiKey: "AIzaSyD_B5jjfUQkCQRQPPZqpvSDgJQkxj1QICE",
		onPlaceSelected: (place) => {

			if (!place.name) {
				const city = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "locality") {
							return obj.long_name;
						}
					});
				});

				const streetNumber = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "street_number") {
							return obj.long_name;
						}
					});
				});

				const postalCode = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "postal_code") {
							return obj.long_name;
						}
					});
				});

				const route = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "route") {
							return obj.long_name;
						}
					});
				});
				const address = streetNumber.long_name + " " + route.long_name;
				setAddressStripeInfos(address, "route");
				setPostalCodeStripeInfos(postalCode.long_name, "cp");
				setCityStripeInfos(city.long_name, "city");
				// setChatBotMessageValue(place.formatted_address);
			} else {
				setAddressStripeInfos(place.name, "route");
			}

		},
		options: {
			types: ["address"],
			componentRestrictions: { country: "fr" },
		},
	});

	const [activeClass, setActiveClass] = useState("");


	return (
		<div className={`response input-smooth ${activeClass} ${valueToActive ? "focus-within" : ""} ${fade} ${fadeOut}`}>
			<input
				name={label}
				id={label}
				type={type}
				className={`input-smooth ${email ? "grey focus-within" : ""}`}
				onFocus={() => {
					setActiveClass("focus-within");
					// onFocus();
				}}
				onBlur={() => {
					// onBlur();
					value ? setActiveClass("focus-within") : setActiveClass("");
				}}
				onChange={(e) => {
					setUserInfos(e.target.value ,"route");
					setAddressStripeInfos(e.target.value);
				}}
				value={value}
				required={required}
				disabled={disabled}
				ref={ref}
				hidden={hidden}
				style={style}
				placeholder=""
			/>
			<input autoComplete="on" style={{ display: "none" }} id="fake-hidden-input-to-stop-google-address-lookup"/>
			<img src={src}/>
			<label htmlFor={label}>{label}</label>
		</div>
	);
};

Input.propTypes = {
	type: PropTypes.string,
	label: PropTypes.string,
	src: PropTypes.string,
	email: PropTypes.bool,
	valueToActive: PropTypes.string,
	value: PropTypes.string,
	fade: PropTypes.string,
	fadeOut: PropTypes.string,
	disabled: PropTypes.any,
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	style: PropTypes.object,
	setAddressStripeInfos: PropTypes.func,
	setCityStripeInfos: PropTypes.func,
	setPostalCodeStripeInfos: PropTypes.func,
	setUserInfos: PropTypes.func,
};

export default Input;